<template>
    <div class="app-container" v-loading="loading">
        <el-row
            style="margin-top: 20px; margin-bottom: 10px"
            :gutter="10"
            class="mb8"
        >
            <el-col :span="3">
                <el-input
                    clearable
                    size="mini"
                    v-model="param.keywords"
                    placeholder="请输入关键字"
                ></el-input>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="warning"
                    icon="el-icon-search"
                    size="mini"
                    @click="GetSearchAnnounce"
                    >搜索</el-button
                >
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    >新增</el-button
                >
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    >修改</el-button
                >
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    >删除</el-button
                >
            </el-col>
        </el-row>
        <el-table
            :data="NoticeArrData"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="selection" width="30" />
            <el-table-column
                label="公告标题"
                prop="announce_title"
            ></el-table-column>
            <el-table-column
                label="公告信息"
                prop="announce_info"
            ></el-table-column>
            <el-table-column label="弹窗内容" prop="popover_info">
                <template slot-scope="scope">
                    <span v-html="scope.row.popover_info"></span>
                </template>
            </el-table-column>
            <el-table-column
                label="弹窗次数"
                prop="popover_num"
            ></el-table-column>
            <el-table-column
                label="弹窗优先级"
                prop="priority"
            ></el-table-column>
            <el-table-column
                label="创建时间"
                prop="create_time"
            ></el-table-column>
            <el-table-column
                label="操作"
                width="160"
                class-name="small-padding fixed-width"
            >
                <template slot-scope="scope">
                    <i
                        class="el-icon-edit"
                        style="
                            margin-left: 10px;
                            color: rgb(24, 144, 255);
                            cursor: pointer;
                        "
                        @click="handleUpdate(scope.row)"
                        >修改</i
                    >
                    <i
                        style="
                            margin-left: 10px;
                            color: rgb(24, 144, 255);
                            cursor: pointer;
                        "
                        class="el-icon-delete"
                        @click="handleDelete(scope.row)"
                        >删除</i
                    >
                </template>
            </el-table-column>
        </el-table>

        <!-- 弹窗新增修改 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="70%"
        >
            <el-form ref="UpdateForm" :rules="rules" :model="UpdateForm" label-width="100px">
                <el-form-item label="公告标题" prop="announce_title">
                    <el-input v-model="UpdateForm.announce_title"></el-input>
                </el-form-item>
                <el-form-item label="公告信息" prop="announce_info">
                    <el-input v-model="UpdateForm.announce_info"></el-input>
                </el-form-item>
                <el-form-item label="弹窗内容" prop="popover_info">
                    <!-- <el-input v-model="UpdateForm.popover_info"></el-input> -->
                    <!-- :minHeight="200" :height="400"  -->
                    <editor v-model="UpdateForm.popover_info"></editor>
                </el-form-item>
                <el-form-item label="弹窗次数" prop="popover_num">
                    <el-input type="number" min="1" v-model.trim="UpdateForm.popover_num"></el-input>
                </el-form-item>
                <el-form-item label="弹窗优先级" prop="priority">
                    <el-input type="number" min="1" v-model.trim="UpdateForm.priority"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="confirm"> 确 认 </el-button>
                <el-button @click="cancel">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import {
    search_announce,
    add_announce,
    update_announce,
    delete_announce,
} from "@/api/NoticeAnnouncement.js";
import editor from "./editor.vue";
export default {
    name: "NoticeAnnouncement",
    components: {
        editor,
    },
    data() {
        return {
            param: {
                keywords: "",
                pageNum: 1,
                pageSize: 10,
            },
            UpdateForm: {},
            rules:{
                announce_title:[
                    { required: true, message: '请输入公告标题', trigger: 'blur' },
                ],
                announce_info:[
                    { required: true, message: '请输入公告信息', trigger: 'blur' },
                ],
                popover_info:[
                    { required: true, message: '请输入弹窗内容', trigger: 'blur' },
                ],
                popover_num:[
                    { required: true, message: '请输入弹窗次数', trigger: 'blur' },
                ],
                priority:[
                    { required: true, message: '请输入弹窗优先级', trigger: 'blur' },
                ],
            },
            NoticeArrData: [],
            total: 0,
            loading: false,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            dialogTitle: null,
            dialogVisible: false,
        };
    },
    created() {
        this.GetSearchAnnounce();
    },
    methods: {
        GetSearchAnnounce() {
            this.loading = true;
            search_announce(this.param)
                .then((res) => {
                    if (res.code == 200) {
                        this.NoticeArrData = res.data.list;
                        this.total = res.data.total;
                        this.loading = false;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSelectionChange(selection) {
            this.ids = selection.map((item) => item.id);
            this.single = selection.length != 1;
            this.multiple = !selection.length;
        },
        handleAdd() {
            this.UpdateForm = {};
            this.dialogTitle = "新增通知公共";
            this.dialogVisible = true;
        },
        handleUpdate(item) {
            this.UpdateForm = JSON.parse(JSON.stringify(item));
            this.dialogTitle = "修改通知公共";
            this.dialogVisible = true;
        },
        handleDelete(item) {
            var id;
            if (item.id) {
                id = [item.id];
            } else {
                id = this.ids;
            }
            this.$confirm("此操作将永久删除该通知公告, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.loading = true;
                    delete_announce({ announce_ids: id })
                        .then((res) => {
                            if (res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                });
                                this.GetSearchAnnounce();
                                this.loading = false;
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                });
                                this.loading = false;
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        confirm() {
            this.loading = true;
            this.$refs['UpdateForm'].validate((valid) => {
                if (valid) {
                    if (this.UpdateForm.id) {
                        update_announce(this.UpdateForm).then((res) => {
                            if(res.code == 200){
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                });
                                this.cancel();
                                this.loading = false;
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                });
                                this.loading = false;
                            }
                        }).catch(()=>{
                            this.loading = false;
                        })
                    } else {
                        let Param = JSON.parse(JSON.stringify(this.UpdateForm))
                        Param.start_time = this.getNowDate()
                        Param.end_time = this.getNowDate()
                        add_announce(this.UpdateForm).then((res) => {
                            if(res.code == 200){
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                });
                                this.cancel();
                                this.loading = false;
                            }else{
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                });
                                this.loading = false;
                            }
                        }).catch(()=>{
                            this.loading = false;
                        })
                    }
                } else {
                    return false;
                }
            });
        },
        cancel() {
            this.UpdateForm = {};
            this.GetSearchAnnounce();
            this.dialogTitle = null;
            this.dialogVisible = false;
        },
        getNowDate() {
            var date = new Date();
            var sign2 = ":";
            var year = date.getFullYear(); // 年
            var month = date.getMonth() + 1; // 月
            var day = date.getDate(); // 日
            var hour = date.getHours(); // 时
            var minutes = date.getMinutes(); // 分
            var seconds = date.getSeconds(); //秒
            // 给一位数的数据前面加 “0”
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            if (hour >= 0 && hour <= 9) {
                hour = "0" + hour;
            }
            if (minutes >= 0 && minutes <= 9) {
                minutes = "0" + minutes;
            }
            if (seconds >= 0 && seconds <= 9) {
                seconds = "0" + seconds;
            }
            return (
                year +
                "-" +
                month +
                "-" +
                day +
                " " +
                hour +
                sign2 +
                minutes +
                sign2 +
                seconds
            );
        },
    },
};
</script>